<button class="btn btn-danger btn-icon-sm" (click)="onClear()" [disabled]="loading || disabledButton">
    <i [ngClass]="(loading && clicked) ? 'spinner-border spinner-border-sm align-middle' : 'fas fa-times'"></i>Clear
</button>
